<template>
  <span
    class="material-icons sm"
    :style="{
      fontSize: '8px',
      color: color,
    }"
  >
    lens
  </span>
</template>

<script>
export default {
  props:{
    color:{
      type:String,
      default:'#626262'
    }
  }
}
</script>

<style>
</style>